import React, { useState, useEffect, useRef } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';

const Navigationbar = () => {

    const isLoggedIn = !!sessionStorage.getItem("token"); // Check if token exists

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("applicationId");
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("userRole");
        sessionStorage.removeItem("status");
        window.location.href = "/login"; // Redirect to login page
    }

    const name= sessionStorage.getItem("userName") || "User";
    const userId= sessionStorage.getItem("userId") || "null";
    const userRole= sessionStorage.getItem("userRole") || "null";
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);
    return (
        <>
            <nav className="navbar navbar-expand-sm">
                <div className="container container_cust">
                    <div className="navbar_cust_main">
                        <a className="navbar-brand navbar_logo" href="#">
                            <img src="/assets/images/logo.png" alt="" />
                        </a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse collapse_center" id="collapsibleNavbar">
                            <ul className="navbar-nav custom_navbar">
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/">Home</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/about-us/">About Us </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/centres/">Centres</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link active" href="#">
                                        <span className="apply_badage">Apply</span>
                                        Fellowship</a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/policy-papers/">Policy Papers</a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/team/">Team</a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/careers/">Careers</a>
                                </li>


                                <li className="nav-item">
                                    <a className="nav-link" href="https://www.bluekraft.in/contact-us/">Contact Us</a>
                                </li>



                            </ul>
                        </div>

                        {isLoggedIn && <div className="dropdown_cust">
                            <Dropdown className="drop_menu" isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle className="card_cusr" >{name}<span className="bi bi-chevron-down"></span></DropdownToggle>
                                <DropdownMenu className="drop_list">

                                    <DropdownItem className="dropcust_item" onClick={handleLogout}>
                                        <span className="bi bi-box-arrow-right" onClick={handleLogout}></span>
                                        Logout
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>}
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navigationbar;